export default {
  pageDescription: {
    id: 'policies_and_eligible_insurances_page_description',
    defaultMessage: 'A description of what you can do here',
  },
}
